export interface IConsentsOverview {
  groupValue: string;
  values: Array<{ id: string; name: string; value: number }>;
}

export enum DateGroupOptionId {
  DAILY = 'daily',
  WEEKLY = 'weekly',
}
